import styled from 'styled-components';

export const StyledWrapper = styled.div`
    width: 100%;
`;

export const StyledChartWrapper = styled.div`
    height: ${({ $height }) => `${$height / 2}px`};
`;
